import { forwardRef } from "react";
import { useSelector } from "react-redux";

import MuiButton, { ButtonProps, ButtonTypeMap } from "@mui/material/Button";
import { ExtendButtonBase } from "@mui/material/ButtonBase";

import { UserRole } from "@models/UserRole";
import { TScope, roleHasPermission } from "@utils/permissions";

type ButtonOptions = {
  permission?: TScope | TScope[];
};

// forwardRef erases generics, so the cast restores MUI's polymorphic `component` typing.
const Button = forwardRef<
  HTMLButtonElement,
  ButtonProps<"button", ButtonOptions>
>(function Button({ permission, ...props }, ref) {
  const role: null | UserRole = useSelector((state: any) => state.user.role);

  if (permission) {
    if (!role) {
      throw new Error(
        "Button with the permission prop must be used within the AuthUserProvider to ensure the user is logged in"
      );
    }
    if (!roleHasPermission(role, permission)) return null;
  }

  return <MuiButton ref={ref} loadingPosition="end" {...props} />;
}) as ExtendButtonBase<ButtonTypeMap<ButtonOptions>>;

export default Button;
